import React, { Component } from 'react'
import Loading from '../Loading'
import DatePicker from 'react-datepicker'
// import NumberFormat from "react-number-format"
import moment from 'moment'
import axios from 'axios'
import { APIURL } from '../../config/config'
import { connect } from 'react-redux'
import { save } from 'save-file';
import { AlertWarning } from '../Alert/Alert'

// nk sell report
class SellReport2 extends Component {

  constructor (props) {
    super(props);
    this.state = {
      isLoading: false,
      date_start: new Date(),
      date_end: new Date(),
      sum_price: 0,
      sum_profit: 0,
      sum_car_cost: 0,
      sum_car_cost_repair: 0,
      sum_car_cost_other: 0,
      sum_car_cost_tax: 0,
      sum_car_cost_act: 0,
      lists: [],
    }
    this.handleDateStart = this.handleDateStart.bind(this)
    this.handleDateEnd = this.handleDateEnd.bind(this)
    this.loadSellData = this.loadSellData.bind(this)
  }

  handleDateStart(date){
    this.setState({
      date_start: date
    })
  }

  handleDateEnd(date){
    this.setState({
      date_end: date
    })
  }

  loadSellData() {
    // const {date_start, date_end} = this.state

    if(this.state.date_start > this.state.date_end){
      AlertWarning('วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ')
      return
    }

    let start_date = moment(this.state.date_start).format('YYYY-MM-DD')
    let end_date   = moment(this.state.date_end).format('YYYY-MM-DD')

    // const data = {
    //   start_date,
    //   end_date
    // }

    this.setState({
      isLoading: true
    })

    axios.get(APIURL + '/report/sell2/'+start_date+'/'+end_date)
      .then(res => {
        let sum_price = 0
        let sum_car_cost = 0
        let sum_car_cost_repair = 0
        let sum_car_cost_other = 0
        let sum_profit = 0
        let sum_car_cost_tax = 0
        let sum_car_cost_act = 0

        if(res.data.length > 0) {
          // console.log(res.data[0])
          sum_price =  res.data.reduce((acc, next) => acc + next.real_sell_price, 0)
          sum_car_cost =  res.data.reduce((acc, next) => acc + next.car_cost, 0)
          sum_car_cost_repair =  res.data.reduce((acc, next) => acc + next.car_cost_repair, 0)
          sum_car_cost_tax = res.data.reduce((acc, next) => acc + next.car_cost_tax, 0)
          sum_car_cost_act = res.data.reduce((acc, next) => acc + next.car_cost_act, 0)
          sum_car_cost_other =  res.data.reduce((acc, next) => acc + next.car_cost_other, 0)
          sum_profit = sum_price - (sum_car_cost + sum_car_cost_repair + sum_car_cost_other)
        }

        this.setState({
          lists: res.data,
          sum_price: sum_price,
          sum_car_cost: sum_car_cost,
          sum_car_cost_repair: sum_car_cost_repair,
          sum_car_cost_other: sum_car_cost_other,
          sum_profit: sum_profit,
          sum_car_cost_tax: sum_car_cost_tax,
          sum_car_cost_act: sum_car_cost_act,
          isLoading: false
        })
      }).catch(error => {
        console.log('error:', error)
       // this.setState({lists: []})
    })

  }

  exportSellData() {

    if(this.state.date_start > this.state.date_end){
      AlertWarning('วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ')
      return
    }

    let start_date =  moment(this.state.date_start).format('YYYY-MM-DD')
    let end_date   =  moment(this.state.date_end).format('YYYY-MM-DD')

    // const data = {
    //   start_date,
    //   end_date
    // }

    this.setState({
      isLoading: true
    }, () => {
      axios.get(APIURL + '/report/sellexport2/'+start_date+'/'+end_date)
        .then( async res => {
          const excelBuffer = res.data.excelBuffer
          const currentDatetime = res.data.currentDatetime
          const fileName = 'รายงานการขาย_export_'+currentDatetime+'.xlsx'
          this.setState({
            isLoading: false
          })
          await save(excelBuffer, fileName)

        }).catch(error => {
        console.log('error:', error)
        // this.setState({lists: []})
        this.setState({
          isLoading: false
        })
      })
    })
  }

  render () {
    const {
      lists,
      sum_price,
      sum_car_cost,
      sum_car_cost_repair,
      sum_car_cost_other,
      sum_profit,
      sum_car_cost_tax,
      sum_car_cost_act
    } = this.state

    const emptyBody = <tr><td colSpan={17} className="text-center text-danger" > ไม่พบข้อมูล </td></tr>

    const listRows = lists.map((car, index) => {
      const car_sell_date = moment(car.car_sell_date).locale('th').format('LL')
      const car_cost = car.car_cost
      const car_cost_repair = car.car_cost_repair
      // ค่าใช้จ่าย พ.ร.บ./ค่าภาษีรถยนต์
      const car_cost_tax = car.car_cost_tax
      // ค่าภาษีรถยนต์
      const car_cost_act = car.car_cost_act
      const car_cost_other = car.car_cost_other
      const gross_profit = car.real_sell_price - (car_cost+car_cost_repair+car_cost_other+car_cost_tax+car_cost_act)

      let structure_name = ''
      const car_structure_name = car.car_structure_name
      if (car_structure_name.indexOf('กระบะ') !== -1) {
        structure_name = 'กระบะ'
      } else if (car_structure_name.indexOf('เก๋ง') !== -1) {
        structure_name = 'เก๋ง'
      } else {
        structure_name = '-'
      }

      return (
        <tr key={index}>
          <td>{index+1}</td>
          <td>{car_sell_date}</td>
          <td>{car.car_brand_name}</td>
          <td>{car.car_model_name}</td>
          <td>{structure_name}</td>
          <td>{car.car_year_name}</td>
          <td>{car.car_license_plate_new}{' '}{car.province_name}</td>
          <td>{car.car_color_name}</td>
          <td>{car.car_gear_name}</td>
          <td>{car.customer_name}</td>
          <td>{car.customer_mobile}</td>
          <td className="text-right">{car.sell_by}</td>
          <td className="text-right">{car.promotion_name}</td>
          <td className="text-right">{car.bank_name}</td>
          <td className="text-right">{car.profile_from === ''? '-': car.profile_from}</td>
          <td>
            {car.gearbox_warranty===null || car.gearbox_warranty==='' ? '-' : car.gearbox_warranty}
          </td>
          <td>
            {car.gearbox_bank_name===null || car.gearbox_bank_name==='' ? '-' : car.gearbox_bank_name}
          </td>

          {/*<td className="text-right">{car.real_sell_price === null ? '-' : car.real_sell_price.toLocaleString()}</td>
          <td className="text-right">{car.car_cost === null ? '-' : car.car_cost.toLocaleString()}</td>
          <td className="text-right">{car.car_cost_repair === null ? '-' : car.car_cost_repair.toLocaleString()}</td>
          <td className="text-right">{car.car_cost_tax === null ? '-' : car.car_cost_tax.toLocaleString()}</td>
          <td className="text-right">{car.car_cost_act === null ? '-' : car.car_cost_act.toLocaleString()}</td>
          <td className="text-right">{car.car_cost_other === null ? '-' : car.car_cost_other.toLocaleString()}</td>
          <td className="text-right">{gross_profit.toLocaleString()}</td>*/}
        </tr>
      )
    })

    const tableRows = lists.length === 0 ? emptyBody : listRows

    // const tableSum = <tr>
    //               <td className="text-right font-weight-bold" colSpan={5}>รวม</td>
    //               <td className="text-right font-weight-bold">{sum_price.toLocaleString()}</td>
    //               <td className="text-right font-weight-bold">{sum_car_cost.toLocaleString()}</td>
    //               <td className="text-right font-weight-bold">{sum_car_cost_repair.toLocaleString()}</td>
    //
    //               <td className="text-right font-weight-bold">{sum_car_cost_tax.toLocaleString()}</td>
    //               <td className="text-right font-weight-bold">{sum_car_cost_act.toLocaleString()}</td>
    //
    //               <td className="text-right font-weight-bold">{sum_car_cost_other.toLocaleString()}</td>
    //               <td className="text-right font-weight-bold">{sum_profit.toLocaleString()}</td>
    //             </tr>

    return (
      <div>
        <Loading isLoading={this.state.isLoading} />

        <div className="card-block">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="card card-accent-primary">
                <div className="card-header">
                  รายงานการขาย
                </div>
                <div className="card-block">

                  <div className="row mt-1">
                    <div className="col-1 text-right">
                      จาก
                    </div>

                    <div className="col-2">
                      <DatePicker
                        selected={this.state.date_start}
                        onChange={this.handleDateStart}
                        dateFormat="yyyy-MM-dd"
                        type="text"
                        className="form-inline"
                        placeholder=""
                      />
                    </div>
                    <div className="col-1 text-center">
                      ถึง
                    </div>
                    <div className="col-2">
                      <DatePicker
                        selected={this.state.date_end}
                        onChange={this.handleDateEnd}
                        dateFormat="yyyy-MM-dd"
                        type="text"
                        className="form-inline d-block"
                        placeholder=""
                      />
                    </div>

                    <div className="col-1">
                      <button type="button" className="btn btn-sm btn-primary" onClick={() => this.loadSellData()} > ตกลง </button>
                    </div>

                    <div className="col-1">
                      <button type="button" className="btn btn-sm btn-success" onClick={() => this.exportSellData()} > Excel </button>
                    </div>

                    <div className="col-5 text-right pt-2">
                      {/*<h5>
                        รวมยอดขาย&nbsp;
                        <NumberFormat
                          displayType={'text'}
                          thousandSeparator={true}
                          value={this.state.sum_expense}/>
                        &nbsp;บาท
                      </h5>*/}
                    </div>
                  </div>

                  <div className="row mt-1">
                    <div className="col-12">
                      <table className="table table-striped">
                        <thead>
                        <tr>
                          <th>ลำดับ</th>
                          <th>วันที่ขาย</th>
                          <th>ยี่ห้อ</th>
                          <th>โมเดล</th>
                          <th>ประเภท</th>
                          <th>รถปี</th>
                          <th>ทะเบียน</th>
                          <th>สี</th>
                          <th>เกียร์</th>
                          <th>ลูกค้า</th>
                          <th>มือถือ</th>
                          <th>ขายโดย</th>
                          <th>โปรโมชั่น</th>
                          <th>ไฟแนนซ์</th>
                          <th>ลูกค้าจาก</th>
                          <th>ประกันเครื่องเกียร์</th>
                          <th>ธนาคารที่รับประกันเครื่องเกียร์</th>

                          {/*<th>ราคาขาย(1)</th>
                          <th>ซื้อรถเข้า(2)</th>
                          <th>ค่าซ่อม(3)</th>
                          <th>ค่าใช้จ่าย พ.ร.บ.(4)</th>
                          <th>ค่าภาษีรถยนต์(5)</th>
                          <th>ค่าใช้จ่ายรถอื่นๆ(6)</th>
                          <th>กำไรเบื้องต้น(7)</th>*/}
                        </tr>
                        </thead>
                        <tbody>
                         {tableRows}

                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})


export default connect(mapStateToProps)(SellReport2);
